import React from "react";
import { AnswerTooltip } from "./AnswerTooltip";
import useRadioAndToolTipQuestion from "../hooks/useRadioAndToolTipQuestion";
import classNames from "classnames";

interface RadioAndToolTipProps {
  question: Question;
  showAsButtons?: boolean;
  replaceManufacturerName?: boolean;
}

export const RadioAndToolTip = ({
  question,
  showAsButtons,
  replaceManufacturerName = false
}: RadioAndToolTipProps) => {
  const {
    answerTooltip,
    error,
    handleChange,
    selectedOption,
    setAnswerTooltip,
    setSelectedOption,
    sortedAnswers
  } = useRadioAndToolTipQuestion({
    question,
    replaceManufacturerName
  });

  return (
    <div className="ch-form__group ch-flex-flow--column-nowrap">
      {error === "radio" && (
        <div className="ch-form__group ch-form__group--error ch-mb--0">
          <span className="ch-form__control-validation ch-mb--1">
            Please choose an option
          </span>
        </div>
      )}
      <div
        className={classNames({
          "button-grid": showAsButtons
        })}
      >
        {sortedAnswers.map((answerObject: any) => (
          <div className="ch-mb--3" key={answerObject.id}>
            <input
              id={`${answerObject.label}`}
              type="radio"
              name={`service-option`}
              className="ch-radio"
              checked={
                selectedOption ? selectedOption[0] === answerObject.id : false
              }
              onChange={() => {
                handleChange(parseInt(answerObject.id));
                setSelectedOption([answerObject.id]);
                if (showAsButtons) {
                  setAnswerTooltip(answerObject.tooltip || "");
                }
              }}
            />
            {
              <label
                htmlFor={`${answerObject.label}`}
                className={classNames(
                  "ch-radio__label ch-radio__label--primary",
                  {
                    "button-label ch-display--flex ch-flex--auto ch-text--center ch-flex-flow--column-no-wrap ch-align-items--center ch-justify-content--center ch-ph--3":
                      showAsButtons
                  }
                )}
              >
                {answerObject.label}
              </label>
            }
            {!showAsButtons &&
              selectedOption &&
              answerObject.id === selectedOption[0] && (
                <div className="ch-mt--2">
                  <AnswerTooltip content={answerObject.tooltip || ""} />
                </div>
              )}
          </div>
        ))}
      </div>
      {showAsButtons && selectedOption && (
        <div className="ch-mt--2">
          <AnswerTooltip content={answerTooltip} />
        </div>
      )}
    </div>
  );
};
